export default "__VITE_ASSET__0_a5sSQC__"